import "./styles.scss";

import Edit from "assets/img/svg/edit";
import { useTranslation } from "react-i18next";

interface InformationTitleProps {
    title: string;
    channelText?: string;
    onClick?: () => void;
}

const InformationTitle = (props: InformationTitleProps) => {
    const { title, channelText, onClick } = props;

    const [t] = useTranslation();

    return (
        <div className="information-title-component">
            <h3 className="information-title-top_title">{title}</h3>
            {channelText && <h4 className="information-title-top_canal">{channelText}</h4>}
            {onClick && <Edit onClick={onClick} />}
        </div>
    );
};

export default InformationTitle;
